import {mobileImage} from "../mobileAssets";
export default function ReservationModal({
    stage,
    form,
    phone,
    codeCountdown,
    isComplete,
    message,
    isCodeLoading,
    isSubmitting,
    onClose,
    onFieldChange,
    onPlatformToggle,
    onSendCode,
    onSubmit
}) {
    if (!stage) return null;
    const handleClose = function () {
        if (document.activeElement && typeof document.activeElement.blur === "function") document.activeElement.blur();
        onClose();
    };

    return (
        <div className="mobile-reservation-mask" onClick={(event) => { if (event.target === event.currentTarget) handleClose(); }}>
            {stage === "form" ? (
                <section className="mobile-reservation-modal" role="dialog" aria-modal="true" aria-labelledby="mobileReservationTitle">
                    <button className="mobile-reservation-close" type="button" onClick={handleClose} aria-label="关闭预约弹窗">
                    <img src={mobileImage("closex_03.png")} alt="TapTap"/>
                    </button>
                    <header>
                        <h2 id="mobileReservationTitle">欢迎预约</h2>
                        <p>玩家你好，请录入信息</p>
                    </header>
                    <form onSubmit={onSubmit}>
                        <label className="mobile-reservation-field"><span className="mobile-visually-hidden">手机号</span><input type="tel" inputMode="numeric" maxLength="11" value={form.phone} placeholder="请输入手机号" onChange={(event) => onFieldChange("phone", event.target.value.replace(/\D/g, ""))}/></label>
                        <label className="mobile-reservation-field mobile-reservation-code"><span className="mobile-visually-hidden">验证码</span><input type="text" inputMode="numeric" maxLength="6" value={form.code} placeholder="请输入验证码" onChange={(event) => onFieldChange("code", event.target.value.replace(/\D/g, ""))}/><button type="button" disabled={!/^1[3-9]\d{9}$/.test(form.phone) || codeCountdown > 0 || isCodeLoading} onClick={onSendCode}>{isCodeLoading ? "发送中" : codeCountdown > 0 ? `${codeCountdown}s` : "发送验证码"}</button></label>
                        <label className="mobile-reservation-agreement"><input type="checkbox" checked={form.agreed} onChange={(event) => onFieldChange("agreed", event.target.checked)}/><span>已同意</span><a href="#/user-agreement" onClick={onClose}>《用户协议》</a><a href="#/privacy-policy" onClick={onClose}>《隐私协议》</a></label>
                        <div className="mobile-reservation-divider"><span>预约平台（可多选）</span></div>
                        <div className="mobile-reservation-platforms">
                            <label className={form.platforms.includes("android") ? "is-selected" : ""}><input type="checkbox" checked={form.platforms.includes("android")} onChange={() => onPlatformToggle("android")}/><span>安卓</span></label>
                            <label className={form.platforms.includes("ios") ? "is-selected" : ""}><input type="checkbox" checked={form.platforms.includes("ios")} onChange={() => onPlatformToggle("ios")}/><span>iOS</span></label>
                        </div>
                        {message ? <p className="mobile-reservation-message" role="status">{message}</p> : null}
                        <button className="mobile-reservation-submit" type="submit" disabled={!isComplete || isSubmitting}>{isSubmitting ? "提交中" : "提交预约"}</button>
                    </form>
                </section>
            ) : (
                <section className="mobile-reservation-modal mobile-reservation-success" role="dialog" aria-modal="true" aria-labelledby="mobileReservationSuccessTitle">
                    <button className="mobile-reservation-close" type="button" onClick={handleClose} aria-label="关闭预约成功弹窗"><img src={mobileImage("closex_03.png")} alt="关闭预约"/></button>
                    <h2 id="mobileReservationSuccessTitle">预约成功</h2>
                    <p className="mobile-reservation-success-phone">{phone ? phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2") : ""}</p>
                    <p>感谢你的预约，期待爱的相见</p>
                    <button className="mobile-reservation-success-close" type="button" onClick={handleClose}>关闭</button>
                </section>
            )}
        </div>
    );
}
